














import { defineComponent } from "@vue/composition-api";
import useAuthUser from "@/hooks/useAuthUser";
import facebook from "@/lib/facebook";
import { $t } from "@/lib/i18nHelpers";
import { loginFacebook, loginTwitter } from "@/lib/loginHelpers";
import twitter from "@/lib/twitter";
import config from "@/config";
import BaseButton from "@/components/BaseButton";
import SocialLoginButton from "./SocialLoginButton.vue";

export default defineComponent({
  name: "SocialLogin",
  components: { SocialLoginButton, BaseButton },
  props: { title: { type: String, default: $t("or log in with") } },
  setup() {
    const { setSocialLoginStatus } = useAuthUser();
    return { setSocialLoginStatus };
  },
  data() {
    return {
      allowedAuth: config.auth,
    };
  },
  computed: {
    hasOauth(): boolean {
      return Object.values(this.allowedAuth).some(v => v);
    },
  },
  methods: {
    async twLogin() {
      try {
        const response = await twitter.login();
        if (!response) {
          return;
        }
        this.setSocialLoginStatus(true);
        const loginResponse = await loginTwitter({
          ...response,
          role: config.userRegistrationRole,
        });
        this.$emit("social", loginResponse.user);
      } catch {
        this.setSocialLoginStatus(false);
      }
    },
    async fbLogin() {
      try {
        const token = await facebook.login();
        this.setSocialLoginStatus(true);
        const loginResponse = await loginFacebook({
          role: config.userRegistrationRole,
          token: token.authResponse.accessToken,
        });
        this.$emit("social", loginResponse.user);
      } catch {
        this.setSocialLoginStatus(false);
      }
    },
  },
});
